export default __webpack_public_path__ + "static/media/favicon.37289d98.ico";